import type * as Blockly from 'blockly/core';
import { expr, registerSetupCode, registerWireBegin, resolveI2CPins } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export const barometricPressureGlobalCodes = new Map<string, string>();

export const seaLevelPressureHelperCode =
    `float _sbeCalcSeaLevelPressure(Adafruit_BMP280& bmp) {\n` +
    `  float pressure = bmp.readPressure();\n` +
    `  float altitude = bmp.readAltitude();\n` +
    `  return pressure / pow(1.0 - (altitude / 44330.0), 5.255);\n` +
    `}\n`;

let _used = false;
let _seaLevelUsed = false;

export function barometricPressureUsed(): boolean {
    return _used;
}

export function seaLevelPressureUsed(): boolean {
    return _seaLevelUsed;
}

export function resetBarometricPressure(): void {
    _used = false;
    _seaLevelUsed = false;
    barometricPressureGlobalCodes.clear();
}

export function register(gen: any): void {
    gen.forBlock['barometric_pressure'] = function (block: Blockly.Block): [string, number] {
        const { sda, scl, board } = resolveI2CPins(block);
        const type = block.getFieldValue('TYPE') as 'PRESSURE' | 'ALTITUDE' | 'SEA_LEVEL_PRESSURE';
        const varName = `_bmp_${sda}`;

        barometricPressureGlobalCodes.set(sda, `Adafruit_BMP280 ${varName};\n`);

        if (board === 'blue') {
            registerWireBegin(`  Wire.begin(${sda}, ${scl});\n`);
        } else {
            registerWireBegin(`  Wire.begin();\n`);
        }
        registerSetupCode(sda, `  ${varName}.begin();\n`);

        _used = true;

        if (type === 'ALTITUDE') {
            return expr(`${varName}.readAltitude()`);
        } else if (type === 'SEA_LEVEL_PRESSURE') {
            _seaLevelUsed = true;
            return expr(`_sbeCalcSeaLevelPressure(${varName}) / 100`);
        } else {
            return expr(`${varName}.readPressure() / 100`);
        }
    };
}
